import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = ["placeholder", "value", "disabled", "tabindex"]
const _hoisted_3 = { key: 2 }

import { ref, toRefs, watch } from 'vue'
import IconChevronUp from '@/design-system/assets/icons/IconChevronUp.vue'
import IconSearch from '@/design-system/assets/icons/IconSearch.vue'
interface HEADER_INPUT_PROPS {
  hasSearch?: boolean
  isOpen: boolean
  searchType?: string
  title: string
  value: string
  disabled?: boolean
}
interface EMITS {
  (e: 'change', value: string): void
  (e: 'focus'): void
  (e: 'toggle'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownHeader',
  props: {
    hasSearch: { type: Boolean },
    isOpen: { type: Boolean },
    searchType: {},
    title: {},
    value: {},
    disabled: { type: Boolean }
  },
  emits: ["change", "focus", "toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { hasSearch, isOpen, searchType, title, value } = toRefs(props)
const inputRef = ref<HTMLInputElement | null>(null)
const onClickArrow = () => {
  if (hasSearch?.value) emits('toggle')
}
const onClickHeader = () => {
  if (!hasSearch?.value) emits('toggle')
}
const onClickInput = () => {
  if (!isOpen.value) emits('toggle')
}
const onChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emits('change', target.value)
}
watch(isOpen, (newValue) => {
  if (!newValue) inputRef.value?.blur()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown-header", {
      'dropdown-header__focus': _unref(isOpen) && _unref(hasSearch),
      'dropdown-header__disabled': _ctx.disabled,
      'dropdown-header__open': _unref(isOpen) && !_unref(hasSearch)
    }]),
    tabindex: _ctx.disabled || _unref(hasSearch) ? -1 : 0,
    onClick: onClickHeader
  }, [
    (_unref(isOpen) && _unref(hasSearch))
      ? (_openBlock(), _createBlock(IconSearch, {
          key: 0,
          class: "dropdown-header__icon"
        }))
      : _createCommentVNode("", true),
    (_unref(hasSearch))
      ? (_openBlock(), _createElementBlock("input", {
          key: 1,
          ref_key: "inputRef",
          ref: inputRef,
          class: _normalizeClass(["dropdown-header__input", { 'dropdown-header__disabled': _ctx.disabled }]),
          placeholder: !_unref(isOpen) ? _unref(title) : `${_ctx.$t('general__text__search')} ${_unref(searchType)}`,
          value: _unref(value),
          disabled: _ctx.disabled,
          tabindex: _ctx.disabled ? -1 : 0,
          onInput: onChange,
          onClick: onClickInput
        }, null, 42, _hoisted_2))
      : _createCommentVNode("", true),
    (!_unref(hasSearch))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", {
            class: _normalizeClass(["dropdown-header__select", { 'dropdown-header__select__disabled': _ctx.disabled }])
          }, _toDisplayString(_unref(title)), 3)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.disabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["dropdown-header__arrow-button", {
        'dropdown-header__arrow-button__rotated': !_unref(isOpen),
        'dropdown-header__arrow-button__disabled': _ctx.disabled
      }]),
          onClick: onClickArrow
        }, [
          _createVNode(IconChevronUp, { class: "dropdown-header__arrow-button__icon" })
        ], 2))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})